import React from 'react'
import { authRoles } from '../../auth/authRoles'

const HotelOwnerRoute = [

    {
        path: '/file_upload',
        component: React.lazy(() => import('./FileUploads/Uploads')),
        auth: authRoles.agent,
    },

    {
        path: '/agent_income',
        component: React.lazy(() => import('./Earning/AgentEarning')),
        auth: authRoles.agent_earning,
    },
]

export default HotelOwnerRoute
